module.exports = __webpack_public_path__ + "img/chinese_5.d551e5a9.png";